import React from 'react';
import {
	Container,
	Box,
	Grid,
	Paper,
	Divider,
	TableContainer,
	Table,
	TableHead,
	TableBody,
	TableRow,
	Avatar,
	withStyles,
	TableCell,
} from '@material-ui/core';
import BodyText from './BodyText';
import DashboardTable from './DashboardTable';
import DashboardTable2 from './DashboardTable2';
import TitleText from './TitleText';
const tableHeaders = [
	'Type',
	'Transaction Date',
	'Transaction Amount',
	'Commission',
	'Markup',
	'Payment Type',
];

const StyledTableCell = withStyles((theme) => ({
	head: {
		fontWeight: 600,
		color: '#8C8C8C',
		padding: 3,
		fontSize: 16,
	},
	root: {
		borderBottom: 'none',
		paddingBottom: 0,
	},
}))(TableCell);
const TransactionHistory = () => {
	return (
		<>
			<Grid container spacing={2}>
				<Box>
					<TitleText
						four
						textStyle={{ fontFamily: 'Josefin Sans, sans-serif' }}>
						Transaction History
					</TitleText>
				</Box>
				<Grid item xs={12}>
					<TableContainer style={{ marginTop: 15 }}>
						<Table>
							<TableHead>
								<TableRow>
									{tableHeaders.map((title, index) => (
										<StyledTableCell key={title}>{title}</StyledTableCell>
									))}
								</TableRow>
							</TableHead>
							<TableBody>
								{[0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12].map((i, index) => {
									return <DashboardTable2 rowIndex={index} />;
								})}
							</TableBody>
						</Table>
					</TableContainer>
				</Grid>
			</Grid>
		</>
	);
};

export default TransactionHistory;
